/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Inbounds_To_AuthorizeInputs */

const en_queue_inbounds_to_authorize = /** @type {(inputs: Queue_Inbounds_To_AuthorizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbounds out of tolerance`)
};

/**
* | output |
* | --- |
* | "Inbounds out of tolerance" |
*
* @param {Queue_Inbounds_To_AuthorizeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_inbounds_to_authorize = /** @type {((inputs?: Queue_Inbounds_To_AuthorizeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Inbounds_To_AuthorizeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_inbounds_to_authorize(inputs)
});